import { Box, Button, Card, CardActions, CardContent, CardHeader, Typography } from "@mui/material";
import { ReactNode } from "react";
import PerfectScrollbar from 'react-perfect-scrollbar'
import "react-perfect-scrollbar/dist/css/styles.css";

type Props = {
    title: string,
    children: ReactNode,
    onNext?: () => void | undefined | Promise<void>,
    onPrevious?: () => void | undefined
    onCancel?: () => void | undefined,
    onFinish?: () => void | undefined | Promise<void>,
    onSkip?: () => void | undefined | Promise<void>
};

const AutoLayout = ({ title, children, onNext, onPrevious, onCancel, onFinish, onSkip }: Props) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', padding: 4, rowGap: 4 }}>
            <Box>{title}</Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflowY: 'auto', minHeight: 0 }}>
                <PerfectScrollbar options={{ wheelPropagation: false }}>
                    {children}
                </PerfectScrollbar>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                {onCancel && <Button variant='contained' onClick={onCancel}>
                    Cancel
                </Button>}
                {onPrevious && <Button variant='contained' onClick={onPrevious}>
                    Previous
                </Button>}
                {onSkip && <Button variant='contained' onClick={onSkip}>
                    Skip
                </Button>}
                {onNext && <Button variant='contained' onClick={onNext}>
                    Next
                </Button>}
                {onFinish && <Button variant='contained' onClick={onFinish}>
                    Finish
                </Button>}
            </Box>
        </Box>
    )
}

export default AutoLayout